<router-outlet *ngIf="!isAuthenticated"></router-outlet>
<app-footer *ngIf="!isAuthenticated"></app-footer>
<div *ngIf="isAuthenticated">
    <div class="container">
        <app-menu> </app-menu>
    </div>
</div>